﻿import { Configurator } from '../configurator';
import { utils } from '../../Foundation';
import { ProductItem } from './models/product-item';
import { ProductItemColletion } from './collections/product-item-collection';
import { Progressable } from '../../Foundation';
import { showHideRelatedOrdersButton } from './warranty-utils/relatedOrders';
import { showHideReplaceReceiverSpecificLabels } from './warranty-utils/replaceReceiversRelated';
import {
  clearSummary,
  resetChosenAccessory,
} from '../configurator/helpers/updateOnConfiguratorActionChange';
import { clearAccessoriesSummaryForRelatedProducts } from '../configurator/helpers/updateOnSeveralToSingleProductChange';
import { checkIfDateBeforeToday, fetchProductData, urlParams } from '../../Foundation/utils';
import { handleExtraRepairRemakeOptions } from './warranty-utils/extraRepairRemakeRelated';
import { BarcodeScanner } from '../barcode-scanner';
/* eslint-disable-next-line */
var qs = require('querystring');

export class Warranty {
  constructor(element) {
    this._refs = {
      el: element,
      //summaryRepair: document.getElementById('warranty-summary-repair-info'),
      userId: document.getElementById('UserIdContainer').innerHTML.trim(),
      apiKey: document.getElementById('UserIdAPIKeyContainer').innerHTML.trim(),
      warrantyApiUrl: document.getElementById('WarrantyAPIUrlContainer').innerHTML.trim(),
      relatedSerialNumberApiUrl: document
        .getElementById('RelatedSerialNumberAPIUrlContainer')
        .innerHTML.trim(),
      serialNumberApiUrl: document.getElementById('SerialNumberAPIUrlContainer').innerHTML.trim(),
      brands: document.getElementById('BrandsContainer').innerHTML.trim(),
      summarySpecifics: document.getElementById('warranty-summary-specifics'), //summaryRepair: document.getElementById('summary-warranty-repair'),
      summaryInitProductImage: document.querySelector('#warranty-product-picture img'),
      toggleButtons: document.getElementById('warranty-toggle-buttons'),
      formsContainer: document.querySelector('.warranty-forms'),
      repairConfigs: document.getElementById('repair-configurators'),
      remakeConfigs: document.getElementById('remake-configurators'),
      extendConfigs: document.getElementById('extend-configurators'),
      registerConfigs: document.getElementById('register-configurators'),
      lndConfigs: document.getElementById('LostAndDamage-configurators'),
      replaceConfigs: document.getElementById('replacereceiver-configurators'),
      repairMainProductSquareLabel:
        document.getElementById('warranty-form-panel').dataset.mainProductLabel,
      submitButton: document.getElementById('warranty-submit'),
      remakeEndDatesOfProducts: [],
      repairEndDatesOfProducts: [],

      // Summary
      summaryCta: document.getElementById('summary-cta'),
      warrantySummary: element.querySelector('.warrantySummary'),
      summaryInitialProductDescription: document.getElementById(
        'summary-initial-product-description',
      ),
      summaryInitialReasons: document.getElementById('summary__initial-product-reasons'),
      summaryRelated: document.getElementById('summary__related-products'),
      mainProductForReplaceReceiversAndLossDamage: document.querySelector(
        '.mainProductForReplaceReceiversAndLossDamage',
      ),
      //submitButton: document.querySelector(".submitorderbutton"),

      sameReasons: true,
      configuratorNameFromActionClick: '',

      // Labels
      serialNumberLabel: document.querySelector('#warranty-form-panel')?.dataset.serialNumberLabel, // TODO: Could we do this smarter and more general?
      patientLabel: document.querySelector('#warranty-form-panel')?.dataset.patientNameLabel,
      repairWarrantyLabel:
        document.querySelector('#warranty-form-panel')?.dataset.repairWarrantyLabel,
      remakeWarrantyLabel:
        document.querySelector('#warranty-form-panel')?.dataset.remakeWarrantyLabel,
      lossAndDamageWarrantyLabel:
        document.querySelector('#warranty-form-panel')?.dataset.lossanddamageWarrantyLabel,
      reasonsLabel: document.getElementById('summary-warranty').dataset.reasonLabel,
      onemultipleDefaultLabel:
        document.querySelector('#warranty-form-panel')?.dataset.oneMultipleDefaultLabel,
      searchMinCharacters:
        document.querySelector('#warranty-form-panel')?.dataset.searchMinCharacters,
      noRelatedProductsText:
        document.querySelector('#warranty-form-panel')?.dataset.noRelatedProductsText,

      // Settings
      remakeProductGroups:
        document.querySelector('#warranty-form-panel')?.dataset.remakeProductGroups,
      replaceProductTypes:
        document.querySelector('#warranty-form-panel')?.dataset.replaceProductTypes,

      configurators: [],

      initialSerialNumber: null,
      // initialProduct: null,
      currentWarrantyAction: null,
      chosenProducts: new ProductItemColletion(),
      progressOverlay: new Progressable(),
      oneMultipleProductsSummary: document.querySelector('.oneMultipleProducts'),
      //For One multiple - none is populated on component init
      relatedDevicesSelect: '',
      selectMultipleRadios: document.querySelectorAll(
        'input[name="warranty-repair-multipleselect-radios"]',
      ),
      relatedProductsSearchField: document.getElementById('relatedProductsSearchField'),
      searchRelatedProductsButton: document.getElementById('searchRelatedProducts'),
      realtedProductsDDOpener: element.querySelector('.relatedProducts__dropdown-opener'),
      realtedProductsDDSearchFireld: document.getElementById('relatedProductsDDSearchField'),
      chosenRelatedProducts: element.querySelector('.relatedProduct-selected'),
      relatedProductsDDHolder: element.querySelector('.relatedProducts__dropdown-holder'),
      searchRelatedProductsResult: document.getElementById('searchRelatedProductsResult'),
      sameReasonsContainer: '',
      sameReasonsCheckbox: '',
      selectrelatedDiv: document.getElementById('warranty-selectrelated'),
      //relatedDevices: document.getElementById("warranty-repair-selectrelated"), // TODO Why is there two?????
    };

    this._initPromise = this.init();

    this.addEventListeners();
  }

  async init() {
    this._refs.initialSerialNumber = utils.getQueryStringParameterByName('id');

    let initProd = await this.loadInitialProduct();

    showHideRelatedOrdersButton();

    initProd.getImageUrlAsync().then((result) => {
      if (result) {
        this._refs.summaryInitProductImage.setAttribute('src', result);
      }
    });

    //EDIT check if it's an edit
    let configurationGuid = utils.getQueryStringParameterByName('configurationGuid');
    if (configurationGuid != null && configurationGuid != '') {
      let action = utils.getQueryStringParameterByName('action');
      //check the action and by it add the configurator in the appropriate div
      let configuratorContainer = document.getElementsByClassName(
        'warranty-' + action + '-reasons',
      )[0];
      const thisRef = this;
      let configurator = new Configurator(configuratorContainer, function () {
        thisRef.toggleSubmitButtonBasedOnConfiguratorsValidation();
      });
      await configurator.createConfiguratorWithValue(
        this._refs.initialSerialNumber,
        'edit',
        action,
        configurationGuid,
      );
      this.hideRepairDetailsTitle(configuratorContainer, action);
      this._refs.configurators.push(configurator);

      // Show action container.
      const form = document.querySelector(
        '.warranty-forms [data-warranty-action="' + action + '"]',
      );

      if (form) {
        form.style.display = 'block';
      }

      // Ensure the action is available for purchase-order logic in edit mode.
      this._refs.currentWarrantyAction = action;

      // Inject and initialise the Purchase Order component for Repair / Remake.
      this.setupPurchaseOrder(form, action);

      //hide not needed elements
      document
        .querySelectorAll('.warranty-hide-on-edit')
        .forEach((element) => element.classList.add('hidden'));

      this.updateSummaryCta(action, true); // TODO: Why is this called from here??? BECAUSE WE NEED TO FILL IN THE CTA ON EDIT TOO
    } else {
      //fill in on left side intitial value for one or multiple products
      //this._refs.oneMultipleProductsSummary.innerText = document.querySelector('#warranty-repair-multipleselect input[type="radio"]:checked').labels[0].innerText.trim();
      //TODO BUG
      this._refs.oneMultipleProductsSummary.innerText = this._refs.onemultipleDefaultLabel;
    }
  }

  setupFormForCurrentAction(configuratorName) {
    // Should we start by taking down everything?
    this._refs.chosenProducts.clearAllExceptInitialProduct();
    this._refs.chosenProducts.getInitialProduct().reasons.clear();
    this.clearRenderedConfigurators();
    //clear configurator from previous actions if clicked
    this._refs.configurators = [];

    switch (this._refs.currentWarrantyAction) {
      case 'repair':
        this.initAction(
          configuratorName,
          this._refs.currentWarrantyAction,
          this._refs.repairConfigs,
        );
        this._refs.configsDivHolder = this._refs.repairConfigs;
        break;
      case 'remake':
        this.initAction(
          configuratorName,
          this._refs.currentWarrantyAction,
          this._refs.remakeConfigs,
        );
        this._refs.configsDivHolder = this._refs.remakeConfigs;
        break;
      case 'extend':
        this.initAction(
          configuratorName,
          this._refs.currentWarrantyAction,
          this._refs.extendConfigs,
        );
        this._refs.configsDivHolder = this._refs.extendConfigs;
        break;
      case 'register':
        this.initAction(
          configuratorName,
          this._refs.currentWarrantyAction,
          this._refs.registerConfigs,
        );
        this._refs.configsDivHolder = this._refs.registerConfigs;
        break;
      case 'LostAndDamage':
        this.initAction(configuratorName, this._refs.currentWarrantyAction, this._refs.lndConfigs);
        this._refs.configsDivHolder = this._refs.lndConfigs;
        break;
      case 'ReplaceReceiver':
        this.initAction(
          configuratorName,
          this._refs.currentWarrantyAction,
          this._refs.replaceConfigs,
        );
        this._refs.configsDivHolder = this._refs.replaceConfigs;
        break;
      default:
        break;
    }
  }

  toggleSubmitButtonBasedOnConfiguratorsValidation() {
    const button = document.getElementById('warranty-submit');
    const allValid = this._refs.configurators?.every((c) =>
      c.fieldValidationState?.every((f) => f.isValid),
    );

    const poValid = this._isPurchaseOrderValid();

    if (allValid && poValid) {
      button.classList.remove('is-disabled');
      button.disabled = false;
    } else {
      button.classList.add('is-disabled');
      button.disabled = true;
    }
  }

  async initAction(configuratorName, configuratorAction, configuratorsDivHolder) {
    // This is in the design at the moment, lets see if we should load a configurator for each product in any other action
    if (configuratorAction == 'ReplaceReceiver') {
      this._refs.sameReasons = false;
    } else {
      this._refs.sameReasons = true;
    }

    this.updateSummery();
    this.updateSummaryCta(configuratorAction);
    await this.updateConfigurators(configuratorName, configuratorAction, configuratorsDivHolder);
    let that = this;

    // clear existing subscriptions from previous actions
    this._refs.chosenProducts.clearSubscriptions();

    this._refs.chosenProducts.subscribe(() => {
      that.updateSummery();
      that.updateChosenProducts();
      that.updateConfigurators(configuratorName, configuratorAction, configuratorsDivHolder);
      that._applyExtendedPurchaseOrderVisibility();
    });
  }

  clearRenderedConfigurators() {
    this._refs.repairConfigs.innerHTML = '';
    this._refs.remakeConfigs.innerHTML = '';
    this._refs.extendConfigs.innerHTML = '';
    this._refs.registerConfigs.innerHTML = '';
    this._refs.replaceConfigs.innerHTML = '';
    this._refs.lndConfigs.innerHTML = '';
  }

  async updateConfigurators(configuratorName, configuratorAction, configuratorsDivHolder) {
    // Get the already loaded configurators
    let configuratorContainers =
      configuratorsDivHolder.getElementsByClassName('configurator__container');

    showHideReplaceReceiverSpecificLabels({ currentAction: this._refs.currentWarrantyAction });

    if (this._refs.sameReasons) {
      // In this case we should only have one repair configurator
      // Remove all configurators except the initial one
      let initConfiguratorExists = false;
      [...configuratorContainers].forEach((configContainer) => {
        if (configContainer.dataset.configuratorSerialNo != this._refs.initialSerialNumber) {
          let product = this._refs.chosenProducts.get(configContainer.dataset.configuratorSerialNo);
          product.reasons.clear();
          configContainer.remove();
          var indexToRemove = this._refs.configurators.findIndex(
            (x) => x.serialNumber == configContainer.dataset.configuratorSerialNo,
          );
          if (indexToRemove > -1) {
            this._refs.configurators.splice(indexToRemove, 1);
          }
        } else {
          initConfiguratorExists = true;
          // The initial product
          // Remove the product info box for the first one if same reason for all
          let relatedProducts = configContainer.getElementsByClassName('relatedProduct');
          while (relatedProducts.length > 0) {
            relatedProducts[0].remove();
          }
        }
      });

      if (!initConfiguratorExists) {
        // No configurator has been loaded for the initial product, so we need to do that.
        let initProduct = this._refs.chosenProducts.getInitialProduct();
        let configuratorContainer = document.createElement('div');
        configuratorContainer.classList.add('configurator__container');
        configuratorContainer.setAttribute('data-configurator-serial-no', initProduct.serialNo);
        configuratorsDivHolder.appendChild(configuratorContainer);
        let thisRef = this;
        let configurator = new Configurator(configuratorContainer, function () {
          thisRef.toggleSubmitButtonBasedOnConfiguratorsValidation();
        });

        this._refs.configurators.push(configurator);
        await configurator.createConfigurator(
          initProduct.serialNo,
          configuratorName,
          'new',
          this._refs.currentWarrantyAction,
        );

        let inputOptions = configuratorContainer.querySelectorAll(
          '[data-id="MultiselectOption"] input',
        );
        inputOptions.forEach((x) => {
          x.addEventListener('change', this._addMultiselectChosenOptionsOnLeftSide.bind(this));
        });

        this.hideRepairDetailsTitle(configuratorContainer);
      }

      //rerun validation to make the submit button disabled/enabled depending on the configurators we have
      this.toggleSubmitButtonBasedOnConfiguratorsValidation();
      return;
    }

    // Remove the configurators where the product is no longer in the collection
    [...configuratorContainers].forEach((configSection) => {
      if (
        configSection.dataset.configuratorSerialNo != this._refs.initialSerialNumber &&
        !this._refs.chosenProducts.exist(configSection.dataset.configuratorSerialNo)
      ) {
        configSection.remove();

        var indexToRemove = this._refs.configurators.findIndex(
          (x) => x.serialNumber == configSection.dataset.configuratorSerialNo,
        );
        if (indexToRemove > -1) {
          this._refs.configurators.splice(indexToRemove, 1);
        }
      }
    });

    // Add the missing configurators for products in the collection
    this._refs.chosenProducts.getAll().forEach(async (product) => {
      // Check if exist
      let confContainer = configuratorsDivHolder.querySelector(
        '.configurator__container[data-configurator-serial-no="' + product.serialNo + '"]',
      );
      const warrantyLabel = () => {
        if (this._refs.currentWarrantyAction === 'remake') return this._refs.remakeWarrantyLabel;
        else if (this._refs.currentWarrantyAction === 'LostAndDamage')
          return this._refs.lossAndDamageWarrantyLabel;
        else return this._refs.repairWarrantyLabel;
      };

      if (confContainer == null) {
        let configuratorContainer = document.createElement('div');
        configuratorContainer.classList.add('configurator__container');
        configuratorContainer.setAttribute('data-configurator-serial-no', product.serialNo);
        configuratorsDivHolder.appendChild(configuratorContainer);

        // If we have multiple products and different repair reasons then insert the product info box
        if (this._refs.chosenProducts.multipleProducts() && !this._refs.sameReasons) {
          this.insertChosenRelatedProduct(
            configuratorContainer,
            product,
            this._refs.serialNumberLabel,
            this._refs.patientLabel,
            warrantyLabel(),
            product.serialNo !== this._refs.initialSerialNumber,
          );
        }

        if (this._refs.chosenProducts.multipleProducts()) {
          //insert configurator title
          configuratorContainer.insertAdjacentHTML(
            'afterBegin',
            this.createConfiguratorTitle(
              configuratorsDivHolder.parentElement.querySelector('[data-configurator-title]')
                .innerText,
            ),
          );
        }

        // Create a new configurator
        // let configurator = new Configurator(this._refs.repairConfigs);
        let thisRef = this;

        let configurator = new Configurator(configuratorContainer, function () {
          thisRef.toggleSubmitButtonBasedOnConfiguratorsValidation();
        });
        this._refs.configurators.push(configurator);
        await configurator.createConfigurator(
          product.serialNo,
          configuratorName,
          'new',
          this._refs.currentWarrantyAction,
        );

        let inputOptions = configuratorContainer.querySelectorAll(
          '[data-id="MultiselectOption"] input',
        );
        inputOptions.forEach((x) => {
          x.addEventListener('change', this._addMultiselectChosenOptionsOnLeftSide.bind(this));
        });

        this.hideRepairDetailsTitle(configuratorContainer);
      } else {
        // Here it's different reasons for each product, so we should show the product in the init configurator
        let productInfoBox = confContainer.getElementsByClassName('relatedProduct');
        if (
          this._refs.chosenProducts.multipleProducts() &&
          (productInfoBox == null || productInfoBox.length == 0)
        ) {
          this.insertChosenRelatedProduct(
            confContainer,
            product,
            this._refs.serialNumberLabel,
            this._refs.patientLabel,
            warrantyLabel(),
            false,
          );
        }
      }
    });

    //rerun validation to make the submit button disabled/enabled depending on the configurators we have
    this.toggleSubmitButtonBasedOnConfiguratorsValidation();
  }

  hideRepairDetailsTitle(
    configuratorContainer,
    configuratorAction = this._refs.currentWarrantyAction,
  ) {
    if (
      configuratorAction !== 'repair' ||
      !configuratorContainer.closest('[data-hide-repair-details-title="true"]')
    ) {
      return;
    }

    configuratorContainer
      .querySelector(
        '.configurator__section > .configurator_reason__selector.configurator_reason__title',
      )
      ?.classList.add('hidden');
  }

  async loadInitialProduct() {
    let initProd = await fetchProductData({
      apiKey: this._refs.apiKey,
      serialNumber: this._refs.initialSerialNumber,
      userId: this._refs.userId,
      warrantyApiUrl: this._refs.warrantyApiUrl,
    });
    initProd.isInitialProduct = true;
    this._refs.chosenProducts.add(initProd);
    return initProd;
  }

  isRepairOrRemake() {
    return (
      this._refs.currentWarrantyAction === 'repair' || this._refs.currentWarrantyAction === 'remake'
    );
  }

  addEventListeners() {
    [...this._refs.toggleButtons.children].forEach((btn) => {
      btn.addEventListener('click', async (event) => {
        await this._initPromise;

        let formid = event.target.getAttribute('data-formid');
        this._refs.currentWarrantyAction = event.target.dataset.warrantyAction; //getAttribute('data-formid');
        //clear configurator from previous actions if clicked
        //this._refs.configurators = [];
        document
          .querySelectorAll('[data-accordion="warranty-accodrion"]')
          .forEach((groupCollapsible) => {
            groupCollapsible.Collapsible.expanded = false;
          });
        // Make all buttons deactive
        [...this._refs.toggleButtons.children].forEach((button) => {
          button.classList.remove('active');
        });

        // Hide the summaries
        [...this._refs.summarySpecifics.children].forEach(
          // (summaryContainer) => { summaryContainer.style.display = "none"; }
          (summaryContainer) => {
            summaryContainer.classList.remove('hidden');
          },
        );

        // Make the specific summary active
        document
          .querySelectorAll('[class*=warranty-action]')
          .forEach((action) =>
            action.classList.contains('hidden') ? '' : action.classList.add('hidden'),
          );
        const actionForClass =
          this._refs.currentWarrantyAction === 'ReplaceReceiver'
            ? 'replace'
            : this._refs.currentWarrantyAction;
        document
          .querySelectorAll('.warranty-action-' + actionForClass)
          .forEach((action) => action.classList.remove('hidden'));
        // let specificSummaryContainer = document.getElementById("summary-" + formid);
        // if (specificSummaryContainer) {
        //     specificSummaryContainer.style.display = "block";
        // }

        // Hide the forms
        [...this._refs.formsContainer.children].forEach((form) => {
          form.style.display = 'none';
        });

        // Make the chosen button and form active
        event.target.classList.add('active');
        let form = document.getElementById(formid);
        document
          .querySelectorAll('[data-insert-one-multiple-here]')
          .forEach((onemultipleholder) => (onemultipleholder.innerHTML = ''));
        form
          .querySelector('[data-insert-one-multiple-here]')
          .insertAdjacentHTML(
            'afterBegin',
            document.getElementById('onemultipleproductscomp').innerHTML,
          );

        //
        document
          .querySelectorAll('[data-insert-purchase-number-here]')
          .forEach((holder) => (holder.innerHTML = ''));

        this.setupPurchaseOrder(form, this._refs.currentWarrantyAction);

        //SET EVERYTHING UP AFTER ADDING THE MULTIPLESELECT
        this._refs.selectMultipleRadios = document.querySelectorAll(
          'input[name="warranty-repair-multipleselect-radios"]',
        );
        this._refs.selectrelatedDiv = document.getElementById('warranty-selectrelated');
        this._refs.relatedDevicesSelect = document
          .getElementById('warranty-selectrelated')
          .querySelector('select');
        this._refs.relatedProductsSearchField = document.getElementById(
          'relatedProductsSearchField',
        );
        this._refs.searchRelatedProductsButton = document.getElementById('searchRelatedProducts');
        this._refs.realtedProductsDDOpener = this._refs.el.querySelector(
          '.relatedProducts__dropdown-opener',
        );
        this._refs.realtedProductsDDSearchFireld = document.getElementById(
          'relatedProductsDDSearchField',
        );
        this._refs.relatedProductsDDHolder = this._refs.el.querySelector(
          '.relatedProducts__dropdown-holder',
        );
        this._refs.searchRelatedProductsResult = document.getElementById(
          'searchRelatedProductsResult',
        );
        this._refs.chosenRelatedProducts = this._refs.el.querySelector('.relatedProduct-selected');

        sessionStorage.setItem('currentWarrantyAction', this._refs.currentWarrantyAction);
        clearSummary({
          summariesToClear: [
            'repair',
            'remake',
            'extend',
            'register',
            'ReplaceReceiver',
            'LostAndDamage',
          ],
        });
        resetChosenAccessory();
        //reset left summary so after changing action there is Amount: One product instead keeping previous one
        this._refs.oneMultipleProductsSummary.innerText =
          this._refs.selectMultipleRadios[0].labels?.[0].innerText?.trim();

        if (this.isRepairOrRemake()) {
          this._refs.sameReasonsContainer = document.querySelector(
            '.warranty-' +
              this._refs.currentWarrantyAction +
              '-reasons #same-' +
              this._refs.currentWarrantyAction +
              '-reasons-container',
          );
          this._refs.sameReasonsCheckbox = document.querySelector(
            '.warranty-' +
              this._refs.currentWarrantyAction +
              '-reasons #same-' +
              this._refs.currentWarrantyAction +
              '-reasons-checkbox',
          );
          this._refs.sameReasonsContainer.style.display = 'none';

          this._refs.sameReasonsCheckbox.addEventListener('change', (e) => {
            this._refs.sameReasons = e.target.checked;
            this.updateSummery();

            // handle checking "same reasons", unchecking is handled separately, when new related product is added so no need to do it twice
            if (e.target.checked) {
              setTimeout(() => {
                const repairEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
                  (item) => item.repairWarrantyEndDate,
                );
                const remakeEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
                  (item) => item.remakeWarrantyEndDate,
                );
                const extraRepairPeriodElements = document.querySelectorAll(
                  '[data-featurekey="ExtraRepairPeriodValue"]',
                );

                handleExtraRepairRemakeOptions({
                  extraRepairPeriodElements,
                  updatedRepairEndDatesOfProducts: repairEndDateOfInitProduct,
                  updatedRemakeEndDatesOfProducts: remakeEndDateOfInitProduct,
                  warrantyAction: this._refs.currentWarrantyAction,
                });
              }, 1000);
            }

            //TODO BUG send configuratorName;
            this.updateConfigurators(
              this._refs.configuratorNameFromActionClick,
              this._refs.currentWarrantyAction,
              this._refs.configsDivHolder,
            ); //.bind(this)
          });
        }

        //ADD EVENT LISTENERS FOR onemultipleselect
        this._refs.realtedProductsDDOpener.addEventListener(
          'click',
          this._relatedProductsDDClick.bind(this),
        );

        [...this._refs.selectMultipleRadios].forEach((radio) => {
          // TODO: Revisit this one. Don't think the show hide should be necessary when we rerender
          radio.addEventListener('change', (e) => {
            let value = e.target.value;
            if (value === 'multiple') {
              // show
              this._refs.selectrelatedDiv.style.display = 'block';
              //this._refs.sameReasonsContainer.style.display = "block";
              if (this.isRepairOrRemake()) {
                document.querySelector(
                  '.warranty-repair-reasons #same-repair-reasons-container',
                ).style.display = 'block';
                document.querySelector(
                  '.warranty-remake-reasons #same-remake-reasons-container',
                ).style.display = 'block';
              }
            } else {
              // hide
              this._refs.selectrelatedDiv.style.display = 'none';
              //this._refs.sameReasonsContainer.style.display = "none";
              if (this.isRepairOrRemake()) {
                document.querySelector(
                  '.warranty-repair-reasons #same-repair-reasons-container',
                ).style.display = 'none';
                document.querySelector(
                  '.warranty-remake-reasons #same-remake-reasons-container',
                ).style.display = 'none';
              }

              // Need to copy the array of product items, as we can't loop an array and remove at the same time
              let products = this._refs.chosenProducts.getAllSerialNumbers(false);
              products.forEach((productSerialNo) => {
                this._refs.chosenProducts.remove(productSerialNo);
              });

              if (this._refs.currentWarrantyAction === 'ReplaceReceiver') {
                clearAccessoriesSummaryForRelatedProducts({
                  serialNumber: this._refs.initialSerialNumber,
                });
              }
            }
            this._refs.oneMultipleProductsSummary.innerText = e.target.labels[0].innerText.trim();
          });
        });

        document.querySelector('.configurator-revamp.warranty').addEventListener('click', (ev) => {
          if (
            !this._refs.relatedProductsDDHolder.contains(ev.target) &&
            this._refs.relatedProductsDDHolder.classList.contains('is-active')
          ) {
            //TODO this code is duplicated - to be moved in one function
            this._refs.relatedProductsDDHolder.classList.remove('is-active');
            if (
              this._refs.relatedProductsDDHolder.querySelector('.relatedProduct-htmlOptions') !=
              null
            ) {
              this._refs.relatedProductsDDHolder
                .querySelector('.relatedProduct-htmlOptions')
                .remove();
            }
          }
          if (
            !this._refs.searchRelatedProductsResult.contains(ev.target) &&
            this._refs.searchRelatedProductsResult.classList.contains('is-active')
          ) {
            this._refs.searchRelatedProductsResult.classList.remove('is-active');
            if (
              this._refs.searchRelatedProductsResult.querySelector('.relatedProduct-htmlOptions') !=
              null
            ) {
              this._refs.searchRelatedProductsResult
                .querySelector('.relatedProduct-htmlOptions')
                .remove();
            }
          }
        });

        this._refs.searchRelatedProductsButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (this._refs.relatedProductsSearchField.value.length < 6) {
            this._refs.searchRelatedProductsResult.innerText = this._refs.searchMinCharacters;
            return;
          }
          this.searchRelatedProductsClick();
        });

        this._refs.relatedProductsSearchField.addEventListener('keypress', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (this._refs.relatedProductsSearchField.value.length < 6) {
              this._refs.searchRelatedProductsResult.innerText = this._refs.searchMinCharacters;
              return;
            }
            this.searchRelatedProductsClick();
          }
        });

        // this._refs.realtedProductsDDSearchFireld.addEventListener('click', event => {
        //     event.preventDefault();
        //     console.log('drop down search filed');
        //     if (this._refs.realtedProductsDDSearchFireld.value.length < 3){
        //         return;
        //     }
        //     this._relatedProductsDDSearchFieldClick();

        // });

        this._refs.realtedProductsDDSearchFireld.addEventListener('keypress', (event) => {
          //("search products from serial number with enter");
          if (event.key === 'Enter') {
            event.preventDefault();
            if (this._refs.realtedProductsDDSearchFireld.value.length < 3) {
              return;
            }
            this._relatedProductsDDSearchFieldClick();
          }
        });

        form.style.display = 'block';
        let configuratorName = event.target.dataset.configuratorname;
        this._refs.configuratorNameFromActionClick = configuratorName;
        this.setupFormForCurrentAction(configuratorName); // We do not setup the form until the user has chosen a functionality like repair, remake etc.

        setTimeout(() => {
          const repairEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
            (item) => item.repairWarrantyEndDate,
          );
          const remakeEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
            (item) => item.remakeWarrantyEndDate,
          );
          const extraRepairPeriodElements = document.querySelectorAll(
            '[data-featurekey="ExtraRepairPeriodValue"]',
          );
          // handle extra repair / remake checkboxes for main product on page load
          handleExtraRepairRemakeOptions({
            extraRepairPeriodElements,
            updatedRepairEndDatesOfProducts: repairEndDateOfInitProduct,
            updatedRemakeEndDatesOfProducts: remakeEndDateOfInitProduct,
            warrantyAction: event.target.dataset.warrantyAction,
          });
          this._refs.repairEndDatesOfProducts = repairEndDateOfInitProduct;
          this._refs.remakeEndDatesOfProducts = remakeEndDateOfInitProduct;
        }, [1000]);

        event.preventDefault();
        return false;
      });
    });

    this._refs.submitButton.addEventListener('click', (event) => {
      //validate PO number before progress overlay is displayed
      if (this.isRepairOrRemake()) {
        if (!this._validatePurchaseOrderNumber()) {
          event.preventDefault();
          return false;
        }
      }

      this._refs.progressOverlay.show();
      let configs = [];

      if (this._refs.sameReasons) {
        // make sure only to get values from the first configurator  (array should only contain 1 configurator at this point, but to make sure.)
        var configuratorValues = this._refs.configurators[0].getValues();
        // clone first configurator object and override serial number to add all products to cart.
        this._refs.chosenProducts.getAll().forEach((product) => {
          const newConfig = JSON.parse(JSON.stringify(configuratorValues));
          // var newConfig = Object.assign({}, );
          newConfig.Data.SerialNumber = product.serialNo;

          configs.push(newConfig);
        });
      } else {
        this._refs.configurators.forEach((conf) => {
          configs.push(conf.getValues());
        });
      }

      if (this.isRepairOrRemake()) {
        const poNumber = this._getPurchaseOrderNumber();
        configs.forEach((config) => {
          config.Data.PONumber = poNumber;
        });
      }

      let postData = {
        Configurators: configs,
      };

      let context = this;
      // Add and go to cart
      // Add to cart
      fetch('/api/config/submitorder', {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(postData), //{'configuratorName': 'configname', 'data': 'some data'})
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // data is an array of responses for each configurator
            let allSuccess = true;
            data.forEach((configResponse) => {
              if (configResponse.Result.Success == false) {
                allSuccess = false;
                var configurator = this._refs.configurators.find(
                  (el) =>
                    el.configuratorId == configResponse.ConfiguratorId &&
                    el.serialNumber == configResponse.SerialNumber,
                );
                configurator.renderServerErrors(configResponse.Result.Errors);
              }
            });

            if (allSuccess) {
              const currentWarrantyAction = urlParams.action;
              const currentConfigurator = postData.Configurators.find(
                (c) => c.action === currentWarrantyAction,
              );
              const cartUrl = document
                .getElementById('warranty-submit')
                ?.getAttribute('data-cart-url');

              if (currentConfigurator?.configurationMode === 'edit' && cartUrl) {
                window.location.href = cartUrl;
              } else {
                context._submitOpenDialog();
              }
            } else {
              context._refs.progressOverlay._remove();
            }
          }
        });

      event.preventDefault();
      return false;
    });
  }

  searchRelatedProductsClick() {
    const postData = {
      UserId: this._refs.userId,
      APIKey: this._refs.apiKey,
      SearchWord: this._refs.relatedProductsSearchField.value,
      Skip: 0,
      Take: 20,
      Brands: this._refs.brands,
      SortColumn: 'SerialNo',
      SortDirection: 'Ascending',
    };

    if (this._refs.currentWarrantyAction === 'ReplaceReceiver') {
      postData.ProductTypeCodes = this._refs.replaceProductTypes;
    }

    const current = this;
    const serialNumberLabel = this._refs.serialNumberLabel;
    const patientNameLabel = this._refs.patientLabel;

    return fetch(this._refs.warrantyApiUrl, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: { 'Content-type': 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.Warranties && data.Warranties.length > 0) {
          if (
            current._refs.searchRelatedProductsResult.querySelector(
              '.relatedProduct-htmlOptions',
            ) != null
          ) {
            current._refs.searchRelatedProductsResult
              .querySelector('.relatedProduct-htmlOptions')
              .remove();
          }
          current._refs.searchRelatedProductsResult.classList.add('is-active');
          current._createDropDownOptions(
            current._refs.searchRelatedProductsResult,
            data.Warranties,
            serialNumberLabel,
            patientNameLabel,
            true,
          );
          current._refs.chosenRelatedProducts
            .querySelectorAll('[data-dropdown-id]')
            .forEach((x) => {
              let inputToBeChecked = current._refs.searchRelatedProductsResult.querySelector(
                'input[type="checkbox"][value="' + x.dataset.dropdownId + '"]',
              ); // TODO: I don't like this
              if (inputToBeChecked) {
                inputToBeChecked.checked = true;
              }
            });
        } else {
          current._refs.searchRelatedProductsResult.innerHTML = '';
          let msg = document.createElement('div');
          msg.innerText = current._refs.noRelatedProductsText;
          msg.classList.add('configurator__validation-msg');
          current._refs.searchRelatedProductsResult.appendChild(msg);
        }
        return null;
      });
  }

  updateSummery() {
    // Rerender the initial product
    this._refs.summaryInitialReasons.innerHTML = '';
    this._refs.summaryInitialProductDescription.innerHTML = '';
    let initProduct = this._refs.chosenProducts.getInitialProduct();
    this._refs.summaryInitialProductDescription.innerHTML = initProduct.description;
    //same reason is not important if one product is chosen
    if (
      (initProduct.reasons.hasReasons() &&
        !this._refs.sameReasons &&
        this._refs.chosenProducts.multipleProducts()) ||
      (initProduct.reasons.hasReasons() && !this._refs.chosenProducts.multipleProducts())
    ) {
      this.renderReasons(this._refs.summaryInitialReasons, initProduct);
    }

    // Rerender the related repair collection in the summaryRelated div.
    // cant clear it if it exist cause I'm loosing the chosen return resons
    this._refs.summaryRelated.innerHTML = '';
    // If same reasons we show the reasons under the main product
    if (this._refs.sameReasons && this._refs.chosenProducts.multipleProducts()) {
      let container = document.createElement('div');
      container.classList.add('repair-summary__product-reasons-container');
      this._refs.summaryRelated.appendChild(container);
      this.renderReasons(container, initProduct);
    }

    //to handle a case when related product is added and for example main product is in warranty, but related product is out of warranty
    setTimeout(() => {
      const repairEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
        (item) => item.repairWarrantyEndDate,
      );
      const remakeEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
        (item) => item.remakeWarrantyEndDate,
      );
      const extraRepairPeriodElements = document.querySelectorAll(
        '[data-featurekey="ExtraRepairPeriodValue"]',
      );

      this._refs.repairEndDatesOfProducts = repairEndDateOfInitProduct;
      this._refs.remakeEndDatesOfProducts = remakeEndDateOfInitProduct;

      handleExtraRepairRemakeOptions({
        extraRepairPeriodElements,
        updatedRepairEndDatesOfProducts: repairEndDateOfInitProduct,
        updatedRemakeEndDatesOfProducts: remakeEndDateOfInitProduct,
        warrantyAction: this._refs.currentWarrantyAction,
      });
    }, [1000]);

    this._refs.chosenProducts.getAll().forEach((product) => {
      if (product.isInitialProduct) {
        return;
      }
      let summaryRelatedProducts = document.createElement('div');
      const serialNo = product.serialNo;
      summaryRelatedProducts.classList.add(
        'configurator_info',
        'configurator_info-related-product',
        `serial-${serialNo}`,
      );
      this._refs.summaryRelated.appendChild(summaryRelatedProducts);

      let productLabel = document.createElement('div');
      productLabel.classList.add('configurator_info__title');
      productLabel.innerHTML = this._refs.warrantySummary?.dataset.relatedProductLabel;
      summaryRelatedProducts.appendChild(productLabel);

      let productName = document.createElement('div');
      productName.classList.add('configurator_info__value');
      productName.innerHTML = product.description;
      summaryRelatedProducts.appendChild(productName);

      if (product.reasons.hasReasons() && !this._refs.sameReasons) {
        this.renderReasons(summaryRelatedProducts, product);
      }
    });
  }

  updateSummaryCta(action, isEdit = false) {
    // Insert title and text
    let titleDiv = this._refs.summaryCta.querySelector('.cta_controller__info-title');
    let title = titleDiv.getAttribute('data-' + action + '-title'); // titleDiv.dataset.repairTitle;
    titleDiv.innerText = title;
    let textDiv = this._refs.summaryCta.querySelector('.cta_controller__info-text');
    let text = textDiv.getAttribute('data-' + action + '-text'); // textDiv.dataset.repairText;
    textDiv.innerText = text;
    this._refs.summaryCta.style.display = 'flex';
    let buttonText = isEdit
      ? this._refs.submitButton.getAttribute('data-' + action + '-edit-text')
      : this._refs.submitButton.getAttribute('data-' + action + '-text'); // this._refs.submitButton.dataset.repairText;
    this._refs.submitButton.innerText = buttonText;
  }

  renderReasons(container, product) {
    if (!product.reasons.hasReasons()) {
      return;
    }
    let reasonsLabel = document.createElement('div');
    reasonsLabel.classList.add('configurator_info__title');
    reasonsLabel.innerHTML = this._refs.reasonsLabel;
    container.appendChild(reasonsLabel);

    let reasons = document.createElement('div');
    reasons.classList.add('configurator_info__value');

    product.reasons.getAll().forEach((reason) => {
      let reasonDiv = document.createElement('p');
      reasonDiv.innerHTML = reason.reasonText;
      reasons.appendChild(reasonDiv);
    });

    container.appendChild(reasons);
  }

  updateChosenProducts() {
    let container = this._refs.chosenRelatedProducts;
    this._refs.chosenRelatedProducts.innerHTML = '';

    let hasInWarrantyProducts = 0;
    let hasOutOfWarrantyProducts = 0;

    let inWarrantyContainer = document.createElement('div');
    let inWarrantyLabel = document.createElement('label');
    inWarrantyLabel.classList.add('in-warranty');
    inWarrantyLabel.innerText = container.dataset.inWarrantyLabel;
    inWarrantyContainer.appendChild(inWarrantyLabel);

    let outOfWarrantyContainer = document.createElement('div');
    let outOfWarrantyLabel = document.createElement('label');
    outOfWarrantyLabel.classList.add('out-of-warranty');
    outOfWarrantyLabel.innerText = container.dataset.outOfWarrantyLabel;
    outOfWarrantyContainer.appendChild(outOfWarrantyLabel);

    this._refs.chosenProducts.getAll().forEach((product) => {
      if (product.isInitialProduct) {
        return;
      }
      const today = new Date().getTime();
      const inRepairWarranty =
        this._refs.currentWarrantyAction === 'repair' &&
        new Date(product.repairWarrantyEndDate).getTime() >= today;
      const inRemakeWarranty =
        this._refs.currentWarrantyAction === 'remake' &&
        new Date(product.remakeWarrantyEndDate).getTime() >= today;
      const inLossAndDamageWarranty =
        this._refs.currentWarrantyAction === 'LostAndDamage' &&
        new Date(product.lossAndDamageWarrantyEndDate).getTime() >= today;
      const ReplaceReceiver =
        this._refs.currentWarrantyAction === 'ReplaceReceiver' &&
        new Date(product.repairWarrantyEndDate).getTime() >= today;
      const warrantyLabel = () => {
        if (this._refs.currentWarrantyAction === 'remake') return this._refs.remakeWarrantyLabel;
        else if (this._refs.currentWarrantyAction === 'LostAndDamage')
          return this._refs.lossAndDamageWarrantyLabel;
        else return this._refs.repairWarrantyLabel;
      };

      if (inRepairWarranty || inRemakeWarranty || inLossAndDamageWarranty || ReplaceReceiver) {
        this.insertChosenRelatedProduct(
          inWarrantyContainer,
          product,
          this._refs.serialNumberLabel,
          this._refs.patientLabel,
          warrantyLabel(),
          true,
          false,
        );
        hasInWarrantyProducts++;
      } else {
        this.insertChosenRelatedProduct(
          outOfWarrantyContainer,
          product,
          this._refs.serialNumberLabel,
          this._refs.patientLabel,
          warrantyLabel(),
          true,
          false,
        );
        hasOutOfWarrantyProducts++;
      }
    });
    inWarrantyLabel.innerText = inWarrantyLabel.innerText + ' (' + hasInWarrantyProducts + ')';
    outOfWarrantyLabel.innerText =
      outOfWarrantyLabel.innerText + ' (' + hasOutOfWarrantyProducts + ')';
    hasInWarrantyProducts > 0 ? container.appendChild(inWarrantyContainer) : '';
    hasOutOfWarrantyProducts > 0 ? container.appendChild(outOfWarrantyContainer) : '';

    let {
      _refs: { selectrelatedDiv },
    } = this;

    const searchRelatedProductsRes = document.getElementById('searchRelatedProductsResult');
    const newRelatedProductInputs = [
      selectrelatedDiv.querySelector('.configurator_reason__selector'),
      selectrelatedDiv.querySelector('.relatedProducts__dropdown'),
      selectrelatedDiv.querySelector('.configurator_reason__description'),
      selectrelatedDiv.querySelector('.input-group'),
    ];

    if (
      this._refs.currentWarrantyAction === 'ReplaceReceiver' &&
      this._refs.chosenProducts.productItems.length > 9
    ) {
      newRelatedProductInputs.forEach((i) => i.classList.add('hidden'));
      searchRelatedProductsRes.innerHTML = '';
    } else {
      newRelatedProductInputs.forEach((i) => i.classList.remove('hidden'));
    }
  }

  insertChosenRelatedProduct(
    container,
    product,
    serialNumberLabel,
    patientLabel,
    warrantyLabel,
    showTrash = true,
    addAtStartOfContainer = true,
  ) {
    let relatedProductContainer = document.createElement('div');
    relatedProductContainer.classList.add('relatedProduct');
    !showTrash ? relatedProductContainer.classList.add('mainProductSquare') : '';
    relatedProductContainer.setAttribute('data-id', product.serialNo);
    relatedProductContainer.setAttribute('data-title', product.description);

    let imageContainer = document.createElement('div');
    imageContainer.classList.add('relatedProduct-item_image');
    relatedProductContainer.appendChild(imageContainer);

    product.getImageUrlAsync().then((result) => {
      if (result) {
        let image = document.createElement('img');
        image.setAttribute('src', result);
        imageContainer.appendChild(image);
      }
    });

    let productDetails = document.createElement('div');
    productDetails.classList.add('relatedProduct-details');
    relatedProductContainer.appendChild(productDetails);
    const warrantyDate = () => {
      if (this._refs.currentWarrantyAction === 'remake') return product.remakeWarrantyEndDate;
      else if (this._refs.currentWarrantyAction === 'LostAndDamage')
        return product.lossAndDamageWarrantyEndDate;
      else return product.repairWarrantyEndDate;
    };
    productDetails.insertAdjacentHTML(
      'afterbegin',
      `
            <div class="relatedProduct-title">${product.description}</div>
            <div class="relatedProduct-info">
                <div>${serialNumberLabel}</div>
                <div>${product.serialNo}</div>
            </div>
            <div class="relatedProduct-info ${
              product.patientName == null || product.patientName?.trim() == '' ? 'hidden' : ''
            }">
                <div>${patientLabel}</div>
                <div>${product.patientName}</div> 
            </div>
            <div class="relatedProduct-info">
                <div>${warrantyLabel}</div>                
                <div>${new Date(warrantyDate()).toLocaleDateString()}</div>
            </div>
        `,
    );

    const repairEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
      (item) => item.repairWarrantyEndDate,
    );
    const remakeEndDateOfInitProduct = this._refs.chosenProducts?.productItems?.map(
      (item) => item.remakeWarrantyEndDate,
    );

    //to handle a case when related product is not with same reasons as the main product
    setTimeout(() => {
      const extraRepairPeriodElements = document.querySelectorAll(
        '[data-featurekey="ExtraRepairPeriodValue"]',
      );

      handleExtraRepairRemakeOptions({
        extraRepairPeriodElements,
        updatedRepairEndDatesOfProducts: repairEndDateOfInitProduct,
        updatedRemakeEndDatesOfProducts: remakeEndDateOfInitProduct,
        warrantyAction: this._refs.currentWarrantyAction,
      });
    }, 1000);
    this._refs.repairEndDatesOfProducts = repairEndDateOfInitProduct;
    this._refs.remakeEndDatesOfProducts = remakeEndDateOfInitProduct;

    if (showTrash) {
      let trashContainer = document.createElement('div');
      trashContainer.setAttribute('data-dropdown-id', product.serialNo);
      relatedProductContainer.appendChild(trashContainer);

      let trash = document.createElement('i');
      trash.classList.add('eva');
      trash.classList.add('eva-trash-2-outline');
      trashContainer.appendChild(trash);

      trash.addEventListener('click', () => {
        this._refs.chosenProducts.remove(product.serialNo);
      });
    } else {
      let labelContainer = document.createElement('div');
      labelContainer.classList.add('small', 'bold-font');
      labelContainer.innerText = this._refs.repairMainProductSquareLabel;
      relatedProductContainer.appendChild(labelContainer);
      //hide the main product square if one is chosen
      // !this._refs.multipleProducts ? relatedProductContainer.classList.add('hidden') : ""; // TODO: Fix this
    }
    addAtStartOfContainer
      ? container.prepend(relatedProductContainer)
      : container.appendChild(relatedProductContainer);
  }

  _relatedProductsDDClick(event) {
    event.preventDefault();
    //("get related products from service");

    if (this._refs.relatedProductsDDHolder.classList.contains('is-active')) {
      this._refs.relatedProductsDDHolder.classList.remove('is-active');
    } else {
      const postData = {
        UserId: this._refs.userId,
        APIKey: this._refs.apiKey,
        serialNumber: this._refs.initialSerialNumber,
        SearchWord: '',
        Skip: 0,
        Take: 20,
        Brands: null,
        SortColumn: 'SerialNo',
        SortDirection: null,
      };

      if (this._refs.currentWarrantyAction === 'ReplaceReceiver') {
        postData.ProductTypeCodes = this._refs.replaceProductTypes;
      }

      const current = this;
      const serialNumberLabel = this._refs.serialNumberLabel;
      const patientNameLabel = this._refs.patientLabel;

      return fetch(this._refs.relatedSerialNumberApiUrl, {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: { 'Content-type': 'application/json' },
      })
        .then((response) => response.json())
        .then((data) => {
          //TODO remove this line when getting real data
          //data.RelatedSerialNumbersWarranties = '[{"InvoiceDate":"2021-05-25T00:00:00","SerialNumber":"2082097029","Patient":"LORI KLEIN","RepairWarrantyEndDate":"2024-06-25T00:00:00","RemakeWarrantyEndDate":"0001-01-01T00:00:00","ModelNo":"","Description":"PKG,CHG KIT,RS,PREM,MFI,XL,US","SellToCustomerNo":"G106083","Brand":"GN RESOUND"},{"InvoiceDate":"2021-05-25T00:00:00","SerialNumber":"2156671586","Patient":"LORI KLEIN","RepairWarrantyEndDate":"2024-06-25T00:00:00","RemakeWarrantyEndDate":"0001-01-01T00:00:00","ModelNo":"RE761-DRWC","Description":"HI,RE761-DRWC,BGE","SellToCustomerNo":"G106083","Brand":"GN RESOUND"}]';
          if (
            data &&
            data.RelatedSerialNumbersWarranties &&
            data.RelatedSerialNumbersWarranties.length > 0
          ) {
            if (
              current._refs.relatedProductsDDHolder.querySelector('.relatedProduct-htmlOptions') !=
              null
            ) {
              current._refs.relatedProductsDDHolder
                .querySelector('.relatedProduct-htmlOptions')
                .remove();
            }
            current._refs.relatedProductsDDHolder.classList.add('is-active');
            current._createDropDownOptions(
              current._refs.relatedProductsDDHolder,
              data.RelatedSerialNumbersWarranties,
              serialNumberLabel,
              patientNameLabel,
            );
            current._refs.chosenRelatedProducts
              .querySelectorAll('[data-dropdown-id]')
              .forEach((x) => {
                let inputToBeChecked = current._refs.relatedProductsDDHolder.querySelector(
                  'input[type="checkbox"][value="' + x.dataset.dropdownId + '"]',
                ); // TODO: I don't like this
                if (inputToBeChecked) {
                  inputToBeChecked.checked = true;
                }
              });
          } else {
            if (
              document.querySelector('.relatedProducts__dropdown .configurator__validation-msg') ==
              null
            ) {
              let msg = document.createElement('div');
              msg.innerText = this._refs.noRelatedProductsText;
              msg.classList.add('configurator__validation-msg');
              document.querySelector('.relatedProducts__dropdown').appendChild(msg);
            }
          }
          return null;
        });
    }
  }

  _relatedProductsDDSearchFieldClick() {
    //console.log("get related products from service with search word");

    const postData = {
      UserId: this._refs.userId,
      APIKey: this._refs.apiKey,
      serialNumber: this._refs.initialSerialNumber,
      SearchWord: this._refs.realtedProductsDDSearchFireld.value,
      Skip: 0,
      Take: 20,
      Brands: null,
      SortColumn: 'SerialNo',
      SortDirection: null,
    };

    if (this._refs.currentWarrantyAction === 'ReplaceReceiver') {
      postData.ProductTypeCodes = this._refs.replaceProductTypes;
    }
    const current = this;
    const serialNumberLabel = this._refs.serialNumberLabel;
    const patientNameLabel = this._refs.patientLabel;

    return fetch(this._refs.relatedSerialNumberApiUrl, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: { 'Content-type': 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          data.RelatedSerialNumbersWarranties &&
          data.RelatedSerialNumbersWarranties.length > 0
        ) {
          if (
            current._refs.relatedProductsDDHolder.querySelector('.relatedProduct-htmlOptions') !=
            null
          ) {
            current._refs.relatedProductsDDHolder
              .querySelector('.relatedProduct-htmlOptions')
              .remove();
          }
          current._refs.relatedProductsDDHolder.classList.add('is-active');
          current._createDropDownOptions(
            current._refs.relatedProductsDDHolder,
            data.RelatedSerialNumbersWarranties,
            serialNumberLabel,
            patientNameLabel,
          );
          current._refs.chosenRelatedProducts
            .querySelectorAll('[data-dropdown-id]')
            .forEach((x) => {
              let inputToBeChecked = current._refs.relatedProductsDDHolder.querySelector(
                'input[type="checkbox"][value="' + x.dataset.dropdownId + '"]',
              ); // TODO: I don't like this
              if (inputToBeChecked) {
                inputToBeChecked.checked = true;
              }
            });
        }
        return null;
      });
  }

  _createDropDownOptions(
    container,
    data,
    serialNumberLabel,
    patientNameLabel,
    isWarrentyData = false,
  ) {
    let { currentWarrantyAction } = this._refs;
    const isLossAndDamage = currentWarrantyAction === 'LostAndDamage'; //to align as "LossAndDamage" within 374516 task
    const isRemake = currentWarrantyAction === 'remake';
    const isRepair = currentWarrantyAction === 'repair';
    const isReplaceReceivers = currentWarrantyAction === 'ReplaceReceiver';
    const isExtendRegisterWarranty =
      currentWarrantyAction === 'extend' || currentWarrantyAction === 'register';

    let list = document.createElement('ul');
    list.classList.add('form-select__list');
    list.classList.add('relatedProduct-htmlOptions');
    list.setAttribute('role', 'listbox');
    container.appendChild(list);

    let remakeProductGroups = this._refs.remakeProductGroups.split(';');

    data.forEach((option) => {
      const isReturned = option.Returned;
      let serialNumber = isWarrentyData ? option.SerialNo : option.SerialNumber;
      const hasRepairWarrantyExpired = checkIfDateBeforeToday(option.RepairWarrantyEndDate);
      const hasLossAndDamageWarrantyExpired = checkIfDateBeforeToday(
        option?.LossAndDamageWarrantyEndDate,
      );

      // Do not include the initial product
      if (serialNumber == this._refs.initialSerialNumber) {
        return; // Continue if initial product
      }

      let productGroup = option.ProductGroupCode;
      let isSelected = this._refs.chosenProducts.exist(serialNumber);
      let allowedForRemake = remakeProductGroups.includes(productGroup);
      const canBeSelectedForRepair = isRepair && !isReturned;
      const canBeSelectedForRemake = isRemake && allowedForRemake && !isReturned;
      const canBeSelectedForExtenedRegister =
        isExtendRegisterWarranty && !hasRepairWarrantyExpired && !isReturned;
      const canBeSelectedForReplace =
        isReplaceReceivers && !hasRepairWarrantyExpired && !isReturned;
      const canBeSelectedForLossAndDamage =
        isLossAndDamage &&
        !option?.IsLossAndDamageUsed &&
        !hasLossAndDamageWarrantyExpired &&
        option?.LossAndDamageWarrantyEndDate &&
        !isReturned;
      let canBeSelected =
        canBeSelectedForRepair ||
        canBeSelectedForReplace ||
        canBeSelectedForRemake ||
        canBeSelectedForExtenedRegister ||
        canBeSelectedForLossAndDamage;

      let listOption = document.createElement('li');
      listOption.classList.add('form-select__list-item');
      if (!canBeSelected) {
        listOption.classList.add('is-disabled');
      }
      listOption.setAttribute('role', 'option');
      listOption.setAttribute('data-option-value', serialNumber);
      list.appendChild(listOption);

      let productInfo = document.createElement('label');
      productInfo.classList.add('relatedProducts__dropdown_product-info');
      productInfo.htmlFor = 'selectrelatedproduct-' + serialNumber;
      listOption.appendChild(productInfo);

      productInfo.insertAdjacentHTML(
        'beforeend',
        `
                <div class="relatedProducts__dropdown_product-info_text">
                    <span class="relatedProducts__dropdown_product-info_text-title">${
                      option.Description
                    }</span>
                    <span class="relatedProducts__dropdown_product-info_text-description">${serialNumberLabel} ${serialNumber}</span>
                    ${
                      option.Patient == null || option.Patient?.trim() == ''
                        ? ''
                        : '<span class="relatedProducts__dropdown_product-info_text-description">' +
                          patientNameLabel +
                          '  ' +
                          option.Patient +
                          '</span>'
                    }  
                </div>
            `,
      );

      let checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = 'selectrelatedproduct-' + serialNumber;
      checkbox.checked = isSelected;
      if (!canBeSelected) {
        checkbox.disabled = true;
      }
      productInfo.appendChild(checkbox);
      checkbox.addEventListener('change', (event) => {
        if (event.target.checked) {
          let productItem = new ProductItem(
            serialNumber,
            option.Description,
            option.Patient,
            option.RepairWarrantyEndDate,
            option.ModelNo,
            option.Color,
            false,
            option.RemakeWarrantyEndDate,
            option.LossAndDamageWarrantyEndDate,
          );
          this._refs.chosenProducts.add(productItem);
        } else {
          this._refs.chosenProducts.remove(serialNumber);
        }
        // console.log(
        //     "drop down: get all",
        //     this._refs.chosenProducts.getAll()
        // );
      });

      let label = document.createElement('label');
      label.setAttribute('for', 'selectrelatedproduct-' + serialNumber);
      label.classList.add('productInfoCheckboxLabel');
      productInfo.appendChild(label);
    });
  }

  _relatedProductsCheckboxChange(event) {
    if (event.srcElement.checked) {
      // Add to product repo
      this._refs.chosenProducts.add(
        new ProductItem(
          event.srcElement.dataset.serialNumber,
          event.srcElement.dataset.title,
          event.srcElement.dataset.patient,
          event.srcElement.dataset.repairWarranty,
          false,
          event.srcElement.dataset.remakeWarranty,
          event.srcElement.dataset.lossAndDamageWarranty,
        ),
      );
    } else {
      // Remove from product repo
      this._refs.chosenProducts.remove(event.srcElement.dataset.serialNumber);
    }
  }

  _submitOpenDialog() {
    if (
      this._refs.currentWarrantyAction == 'extend' ||
      this._refs.currentWarrantyAction == 'register'
    ) {
      document.querySelector('.warranty-hide-on-extened-register').classList.add('hidden');
    }
    let html = '';
    this._refs.chosenProducts.getAll().forEach(async (relatedProduct) => {
      html =
        html +
        `  <li class="dialog_relatedProduct" data-id="${relatedProduct.serialNo}">
                    <div class="dialog_relatedProduct-item_image">
                        <img src="${
                          relatedProduct.imageUrl != null ? relatedProduct.imageUrl : ''
                        }" />
                    </div>
                    <div class="dialog_relatedProduct-details">
                        <div class="dialog_relatedProduct-title">${relatedProduct.description}</div>
                        <p>${relatedProduct.serialNo}</p>
                    </div>
                </li> `;
    });
    document.querySelector('.dialog_relatedProduct-list').insertAdjacentHTML('beforeend', html);
    const dialogElement = document.querySelector('.dialog-submit-warranty');
    if (typeof dialogElement.showModal === 'function') {
      dialogElement.showModal();
    } else {
      outputBox.value = 'Sorry, the <dialog> API is not supported by this browser.';
    }
  }

  createConfiguratorTitle(title) {
    return `
        <div class="configurator_reason__selector">
            <p class="configurator_reason__title bold-font">
                ${title}
            </p>
        </div>
         `;
  }

  _addMultiselectChosenOptionsOnLeftSide(e) {
    //console.log('_addMultiselectChosenOptionsOnLeftSide start');
    const serialNo = e.target.closest('[data-configurator-serial-no]').dataset.configuratorSerialNo;
    const reasonId = e.target.value;
    const reasonText = e.srcElement.labels[0].innerText;

    // Now get the product object
    let product = this._refs.chosenProducts.get(serialNo);
    if (e.srcElement.checked) {
      product.addReason(reasonId, reasonText);
      document
        .querySelectorAll(
          '.configurator__section[data-configurator-serial-no="' +
            serialNo +
            '"] .configurator__multiselect-chosenoptions_option i',
        )
        .forEach((x) => x.addEventListener('click', this._removeMultiselectOption.bind(this)));
    } else {
      //console.log("else remove");
      product.removeReason(reasonId);
    }
    this.updateSummery();
    // do not call "productsUpdated", as we are not updating products, but only Summery
    // this is causing some issues because it is comparing the HTML with configurators array and it breaks, because the holder of configurators are different per action
    //this._refs.chosenProducts.productsUpdated();
  }

  _removeMultiselectOption(e) {
    const checkboxId = e.srcElement.parentElement.dataset.checkboxId;
    const serialNo = checkboxId.split('{')[0];
    let product = this._refs.chosenProducts.get(serialNo);
    product.removeReason(checkboxId.split(serialNo)[1]);

    this.updateSummery();
    // do not call "productsUpdated", as we are not updating products, but only Summery
    // this is causing some issues because it is comparing the HTML with configurators array and it breaks, because the holder of configurators are different per action
    //this._refs.chosenProducts.productsUpdated();
  }

  _validatePurchaseOrderNumber() {
    const input = document.getElementById('PurchaseOrderNoTextBox');
    if (!input || !this._isPurchaseOrderSectionVisible(input)) return true;

    if (input.dataset.validationExtendedLogic === 'true') {
      if (this._allProductsInWarranty()) return true;
    }

    const value = input.value.trim();
    const errorPanel = document.getElementById('PurchaseOrderNoErrorPanel');
    const invalidPanel = document.getElementById('PurchaseOrderNoInvalidPanel');
    const fieldSizePanel = document.getElementById('PurchaseOrderNoFieldSizeErrorPanel');
    const digitsPanel = document.getElementById('PurchaseOrderNoOnlyDigitsAndLenthMessagePanel');

    // Reset all error panels
    [errorPanel, invalidPanel, fieldSizePanel, digitsPanel].forEach(
      (p) => p && (p.style.display = 'none'),
    );

    const isOptional = input.dataset.validationOptional === 'true';

    // Required but empty
    if (!isOptional && !value) {
      if (errorPanel) errorPanel.style.display = '';
      return false;
    }

    if (value) {
      // Invalid start character
      if (/^[=+\-/']/.test(value)) {
        if (invalidPanel) invalidPanel.style.display = '';
        return false;
      }

      // Digits only + fixed length
      const requiredLength = parseInt(input.dataset.validationDigitsOnlyLength, 10);
      if (requiredLength > 0) {
        if (!/^\d+$/.test(value) || value.length !== requiredLength) {
          if (digitsPanel) digitsPanel.style.display = '';
          return false;
        }
      }

      // Field length (maxlength=20 is handled by the browser, but check explicitly))
      if (value.length > parseInt(input.getAttribute('maxlength') || '20', 10)) {
        if (fieldSizePanel) fieldSizePanel.style.display = '';
        return false;
      }
    }

    return true;
  }

  _isPurchaseOrderValid() {
    const input = document.getElementById('PurchaseOrderNoTextBox');
    if (!input || !this._isPurchaseOrderSectionVisible(input)) return true;

    if (input.dataset.validationExtendedLogic === 'true') {
      if (this._allProductsInWarranty()) return true;
    }

    const value = input.value.trim();
    const isOptional = input.dataset.validationOptional === 'true';

    // Required but empty
    if (!isOptional && !value) return false;

    if (value) {
      // Invalid start character
      if (/^[=+\-/']/.test(value)) return false;

      // Digits only + fixed length
      const requiredLength = parseInt(input.dataset.validationDigitsOnlyLength, 10);
      if (requiredLength > 0) {
        if (!/^\d+$/.test(value) || value.length !== requiredLength) return false;
      }

      // Field length
      if (value.length > parseInt(input.getAttribute('maxlength') || '20', 10)) return false;
    }

    return true;
  }

  _isPurchaseOrderSectionVisible(input) {
    const section = input.closest('.purchase-order-number-section');
    return !section || window.getComputedStyle(section).display !== 'none';
  }

  _getPurchaseOrderNumber() {
    const input = document.getElementById('PurchaseOrderNoTextBox');
    return input ? input.value.trim() : '';
  }

  updatePurchaseNumberSummary() {
    const poInput = document.getElementById('PurchaseOrderNoTextBox');
    const purchaseNumberValue = document.getElementById('PurchaseNumberValue');
    const purchaseNumberSummary = document.getElementById('PurchaseNumberSummary');

    if (poInput) {
      purchaseNumberValue.innerText = poInput.value;
    }

    if (purchaseNumberSummary) {
      const hasValue = poInput ? poInput.value.trim().length > 0 : false;
      purchaseNumberSummary.classList.toggle('hidden', !hasValue);
    }

    this.toggleSubmitButtonBasedOnConfiguratorsValidation();
  }

  _applyExtendedPurchaseOrderVisibility() {
    const poInput = document.getElementById('PurchaseOrderNoTextBox');
    if (!poInput) {
      return;
    }
    if (poInput.dataset.validationExtendedLogic !== 'true') {
      return;
    }

    const allInWarranty = this._allProductsInWarranty();

    poInput
      .closest('[data-insert-purchase-number-here]')
      ?.style.setProperty('display', allInWarranty ? 'none' : '');
    document.getElementById('PurchaseNumberSummary')?.classList.toggle('hidden', allInWarranty);
  }

  _getWarrantyEndDateForAction(product) {
    if (this._refs.currentWarrantyAction === 'remake') return product?.remakeWarrantyEndDate;
    if (this._refs.currentWarrantyAction === 'repair') return product?.repairWarrantyEndDate;
    return null;
  }

  _allProductsInWarranty() {
    return this._refs.chosenProducts.getAll().every((product) => {
      const endDate = this._getWarrantyEndDateForAction(product);
      return endDate && new Date(endDate).getTime() > Date.now();
    });
  }

  _onPurchaseOrderChange() {
    this.updatePurchaseNumberSummary();
    this._validatePurchaseOrderNumber();
  }

  setupPurchaseOrder(form, action) {
    if (!form) {
      return;
    }

    if (action !== 'repair' && action !== 'remake') {
      document.getElementById('PurchaseNumberValue')?.replaceChildren();
      document.getElementById('PurchaseNumberSummary')?.classList.add('hidden');
      return;
    }

    const holder = form.querySelector('[data-insert-purchase-number-here]');
    const template = document.getElementById('purchasenumbercomp');

    if (!holder || !template || holder.querySelector('#PurchaseOrderNoTextBox')) {
      return;
    }

    holder.insertAdjacentHTML('afterBegin', template.innerHTML);

    const poInput = document.getElementById('PurchaseOrderNoTextBox');
    if (!poInput) return;

    if (poInput.dataset.validationBarcode === 'true') {
      new BarcodeScanner(poInput);
    }

    poInput.addEventListener('change', this._onPurchaseOrderChange.bind(this));
    this.updatePurchaseNumberSummary();
    this._applyExtendedPurchaseOrderVisibility();
  }
}
